var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Dashboard"},[_c('h2',[_vm._v("VDI Pool")]),_c('h4',[_vm._v("UK")]),_c('vdis-overview',{attrs:{"vdiList":_vm.vdiList.filter(v => v.location === 'uk')}}),_c('h4',[_vm._v("US")]),_c('vdis-overview',{attrs:{"vdiList":_vm.vdiList.filter(v => v.location === 'us')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }